// package.json
var version = "11.4.1";

export {
  version
};
